import CollectionApi from 'client/api/v2/CollectionApi';

class AppleVppApi extends CollectionApi {
  constructor() {
    super('/api/v2/applevpp', {
      skip: 0,
      limit: 50,
    });
  }

  /**
   * @param {string} locationId locationId of each sToken
   */
  deleteSToken(locationId) {
    return this.axios.delete(`${this.baseUrl}/locations/${locationId}`);
  }

  /**
   * Submits an sToken (location) to the service.
   */
  postSToken(payload) {
    return this.axios.post(`${this.baseUrl}/locations`, payload)
      .then(resp => ((resp && resp.data) || {}));
  }

  /**
   * Renews a given token
   */
  putSToken(payload) {
    return this.axios.put(`${this.baseUrl}/locations/${payload.tokenId}`, { sToken: payload.sToken });
  }

  /**
   * Retrieves all the tokens (locations)
   */
  getLocations() {
    return this.axios.get(`${this.baseUrl}/locations`)
      .then((resp) => {
        const locations = (resp && resp.data) || [];
        const totalCount = parseInt(resp.headers['x-total-count'], 10);

        return { locations, totalCount };
      });
  }
}
export default new AppleVppApi();
